import React from 'react';

import styles from './recentIdeaListStyles';

import DelayedAccessAlert, {
  Location
} from 'buyside/components/presentation/AccessControl/delayedAccessAlert';
import Link from 'buyside/components/presentation/Link/link';
import RecentIdea from 'buyside/components/presentation/RecentIdea/recentIdea';

import LightbulbIcon from 'buyside/svgs/lightbulb_2.svg';

import { newIdeaUrl, inviteMembersUrl } from 'buyside/util/urlHelper';

const RecentIdeaList = ({ ideas, currentUser, limit = 4 }) => {
  if (!ideas || !ideas.edges || ideas.edges.length === 0) {
    return (
      <div>
        <div className={styles.wrap}>
          <LightbulbIcon className={styles.bigBulb} />
          <h4 className={styles.h4}>Got any bright ideas?</h4>
          <p className={styles.smallText}>
            There’s currently no recent research for this company.
            {currentUser && currentUser.canWriteIdeas && (
              <span>
                Be the first to
                <Link to={newIdeaUrl()}> submit your own research</Link>
                on this or any other company.
              </span>
            )}
            <span>
              {' '}
              If you know someone who might be an expert on this company, why not
              <Link to={inviteMembersUrl()}> invite them to SumZero</Link>?
            </span>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h6 className={styles.h6}>Recent Ideas</h6>
      <DelayedAccessAlert id={Location.corporateActionFeed} />
      {ideas.edges.slice(0, limit).map((edge, idx) => (
        <div key={idx} className={styles.recentIdeaContainer}>
          <RecentIdea
            idea={edge.node}
            key={`${edge.node.id}-${idx}`}
            showUserDetails={currentUser && currentUser.canViewUserDetails}
          />
        </div>
      ))}
    </div>
  );
};

export default RecentIdeaList;
